var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ListingSettingsHeader", {
    attrs: {
      displayTotalResults: !_vm.isTableLoading,
      totalResults: _vm.totalActivities,
      filters: _vm.filtersEnabled,
      columns: _vm.columns,
      enableColumnsSettings: true
    },
    on: {
      selectFilter: _vm.updateActiveFilters,
      updateColumns: function(newColumns) {
        return _vm.$emit("updateColumns", newColumns)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "filters",
        fn: function() {
          return _vm._l(_vm.getActiveFilters, function(activeFilter) {
            return _c(
              activeFilter.component,
              _vm._b(
                {
                  key: activeFilter.code,
                  tag: "component",
                  staticClass: "listing-table-filters__item",
                  attrs: { filter: activeFilter },
                  on: {
                    "update:displayDropdown": function(value) {
                      activeFilter.displayDropdown = value
                    },
                    updateFilter: function(values) {
                      activeFilter.callback(values, activeFilter)
                    },
                    updateFilterOptions: function(options) {
                      activeFilter.optionsSelected = options
                    },
                    removeFilter: function($event) {
                      return _vm.removeActiveFilter(activeFilter)
                    }
                  }
                },
                "component",
                activeFilter,
                false
              )
            )
          })
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }